/* eslint-disable no-restricted-imports */

import {
  Box,
  Button,
  Chip,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons';

import { FormatMoney } from 'components';
import { ProductSearchAsync } from 'components/Contigo';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(3),
  },
  addButton: {
    height: 56,
    minWidth: 140,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  tableContainer: {
    marginTop: theme.spacing(3),
    boxShadow: theme.shadows[2],
  },
}));

export default function ProductSelectionStep({
  selectedProduct,
  onProductSelect,
  productQuantity,
  onQuantityChange,
  onAddProduct,
  orderItems,
  onRemoveProduct,
}) {
  const classes = useStyles();

  return (
    <Box>
      <Typography variant='h6' gutterBottom>
        Adicionar Produtos ao Pedido
      </Typography>

      <Grid container spacing={2} alignItems='flex-end' className={classes.section}>
        <Grid item xs={12} md={6}>
          <ProductSearchAsync
            value={selectedProduct}
            onChange={onProductSelect}
            label=''
            placeholder='Digite o part number ou descrição (mínimo 3 caracteres)...'
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            type='number'
            label='Quantidade'
            variant='outlined'
            value={productQuantity}
            onChange={(e) => onQuantityChange(parseInt(e.target.value) || 1)}
            inputProps={{ min: 1 }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Button
            fullWidth
            variant='contained'
            color='primary'
            startIcon={<AddIcon />}
            onClick={onAddProduct}
            disabled={!selectedProduct || productQuantity <= 0}
            className={classes.addButton}
          >
            Adicionar
          </Button>
        </Grid>
      </Grid>

      {orderItems.length > 0 && (
        <>
          <Typography variant='subtitle1' gutterBottom style={{ marginTop: 24 }}>
            Produtos Adicionados ({orderItems.length})
          </Typography>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Part Number</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Descrição</strong>
                  </TableCell>
                  <TableCell align='center'>
                    <strong>Quantidade</strong>
                  </TableCell>
                  <TableCell align='right'>
                    <strong>Preço Venda (un)</strong>
                  </TableCell>
                  <TableCell align='center'>
                    <strong>Ações</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orderItems.map((item) => (
                  <TableRow key={item.part_number} hover>
                    <TableCell>{item.part_number}</TableCell>
                    <TableCell>{item.description}</TableCell>
                    <TableCell align='center'>
                      <Chip label={item.quantity} color='primary' size='small' />
                    </TableCell>
                    <TableCell align='right'>
                      <Typography variant='body2' style={{ color: '#2E7D32', fontWeight: 500 }}>
                        <FormatMoney>{item.sell_price || 0}</FormatMoney>
                      </Typography>
                    </TableCell>
                    <TableCell align='center'>
                      <IconButton
                        size='small'
                        onClick={() => onRemoveProduct(item.part_number)}
                        color='secondary'
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </Box>
  );
}

ProductSelectionStep.propTypes = {
  selectedProduct: PropTypes.object,
  onProductSelect: PropTypes.func.isRequired,
  productQuantity: PropTypes.number.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
  onAddProduct: PropTypes.func.isRequired,
  orderItems: PropTypes.array.isRequired,
  onRemoveProduct: PropTypes.func.isRequired,
};
